<div class="container-fluid p-3">

  <!-- HEADER -->
  <div class="d-flex flex-column flex-md-row justify-content-between
              align-items-start align-items-md-center gap-3 mb-4 flex-wrap">
    <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
      {{ 'ADMIN.ACADEMIC_PERIODS' | translate }}
    </h4>
    <app-button
      *ngIf="canWrite"
      (click)="openAddModal()"
      [label]="'ADMIN.ADD_ACADEMIC_PERIOD' | translate"
      [customClasses]="'fs-14 fg-600 py-2 px-5 btn-create-test'"
      [type]="'button'">
    </app-button>
  </div>

  <app-read-only-notice *ngIf="!canWrite"></app-read-only-notice>

  <!-- LOADING -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
    </div>
    <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
  </div>

  <!-- ERROR -->
  <div *ngIf="error && !isLoading" class="alert alert-danger" role="alert">
    <i class="fa-solid fa-circle-exclamation me-2"></i>
    {{ error }}
    <button type="button" class="btn btn-sm btn-outline-danger ms-3"
            (click)="loadPeriods()">
      <i class="fa-solid fa-rotate-right me-1"></i>
      {{ 'COMMON.RETRY' | translate }}
    </button>
  </div>

  <!-- TABLE -->
  <!--
    ✅ On passe periodsForDisplay (avec isActiveLabel traduit)
       mais les boutons utilisent data.isActive (boolean original)
       car isActiveLabel est copié via spread {...p}
  -->
  <app-custom-tab
    *ngIf="!isLoading && !error && periodsForDisplay.length > 0"
    [data]="periodsForDisplay"
    [columns]="periodColumns"
    [actionTemplate]="periodActionsTemplate"
    [locale]="currentLocale"
    [enableRtl]="isRTL">

    <ng-template #periodActionsTemplate let-data>

      <!-- VIEW — gris, toujours visible -->
      <button
        class="btn btn-sm btn-secondary mx-1"
        (click)="view(data); $event.stopPropagation()"
        [title]="'COMMON.VIEW' | translate">
        <i class="fa-solid fa-eye"></i>
      </button>

      <!-- EDIT — bleu, à qui peut modifier -->
      <button
        *ngIf="canWrite"
        class="btn btn-sm btn-primary mx-1"
        (click)="editPeriod(data); $event.stopPropagation()"
        [title]="'COMMON.EDIT' | translate">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>

      <!-- ACTIVATE — vert, seulement si inactif -->
      <button
        *ngIf="canWrite && !data.isActive"
        class="btn btn-sm btn-success mx-1"
        (click)="activate(data); $event.stopPropagation()"
        [title]="'COMMON.ACTIVATE' | translate">
        <i class="fa-solid fa-check"></i>
      </button>

      <!-- DEACTIVATE — orange, seulement si actif -->
      <button
        *ngIf="canWrite && data.isActive"
        class="btn btn-sm btn-warning mx-1"
        (click)="deactivate(data); $event.stopPropagation()"
        [title]="'COMMON.DEACTIVATE' | translate">
        <i class="fa-solid fa-ban"></i>
      </button>

      <!-- DELETE — rouge, seulement si inactif -->
      <button
        *ngIf="canWrite && !data.isActive"
        class="btn btn-sm btn-danger mx-1"
        (click)="deletePeriod(data); $event.stopPropagation()"
        [title]="'COMMON.DELETE' | translate">
        <i class="fa-solid fa-trash-can"></i>
      </button>

    </ng-template>

  </app-custom-tab>

  <!-- EMPTY STATE -->
  <div *ngIf="!isLoading && !error && periodsForDisplay.length === 0"
       class="text-center py-5">
    <i class="fa-solid fa-calendar-xmark fa-3x text-muted mb-3 d-block"></i>
    <p class="text-muted">{{ 'ADMIN.NO_PERIODS_FOUND' | translate }}</p>
    <app-button
      *ngIf="canWrite"
      (click)="openAddModal()"
      [label]="'ADMIN.ADD_ACADEMIC_PERIOD' | translate"
      [customClasses]="'fs-14 fg-600 py-2 px-4 btn-create-test'"
      [type]="'button'">
    </app-button>
  </div>

</div>

<!-- VIEW PERIOD MODAL -->
<app-modal
  [title]="'ADMIN.VIEW_ACADEMIC_PERIOD' | translate"
  [size]="'lg'"
  [show]="showViewModal"
  [hasFooter]="false"
  (closed)="closeViewModal()">

  <div *ngIf="viewPeriod" class="p-2">

    <!-- Name -->
    <div class="d-flex justify-content-between align-items-center py-3
                border-bottom">
      <span class="fw-semibold text-muted">
        {{ 'DATA_TABLE.NAME' | translate }}
      </span>
      <span class="fw-bold">{{ viewPeriod.name }}</span>
    </div>

    <!-- Start Date -->
    <div class="d-flex justify-content-between align-items-center py-3
                border-bottom">
      <span class="fw-semibold text-muted">
        {{ 'DATA_TABLE.START_DATE' | translate }}
      </span>
      <span>{{ viewPeriod.startDate }}</span>
    </div>

    <!-- End Date -->
    <div class="d-flex justify-content-between align-items-center py-3
                border-bottom">
      <span class="fw-semibold text-muted">
        {{ 'DATA_TABLE.END_DATE' | translate }}
      </span>
      <span>{{ viewPeriod.endDate }}</span>
    </div>

    <!-- Status -->
    <div class="d-flex justify-content-between align-items-center py-3
                border-bottom">
      <span class="fw-semibold text-muted">
        {{ 'DATA_TABLE.STATUS' | translate }}
      </span>
      <span *ngIf="viewPeriod.isActive"
            class="badge bg-success px-3 py-2">
        <i class="fa-solid fa-circle-check me-1"></i>
        {{ 'COMMON.ACTIVE' | translate }}
      </span>
      <span *ngIf="!viewPeriod.isActive"
            class="badge bg-secondary px-3 py-2">
        <i class="fa-solid fa-circle-xmark me-1"></i>
        {{ 'COMMON.INACTIVE' | translate }}
      </span>
    </div>

    <!-- Created At -->
    <div class="d-flex justify-content-between align-items-center py-3
                border-bottom">
      <span class="fw-semibold text-muted">
        {{ 'DATA_TABLE.CREATED_AT' | translate }}
      </span>
      <span>{{ viewPeriod.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
    </div>

    <!-- Updated At -->
    <div class="d-flex justify-content-between align-items-center py-3">
      <span class="fw-semibold text-muted">
        {{ 'DATA_TABLE.UPDATED_AT' | translate }}
      </span>
      <span *ngIf="viewPeriod.updatedAt">
        {{ viewPeriod.updatedAt | date:'dd/MM/yyyy HH:mm' }}
      </span>
      <span *ngIf="!viewPeriod.updatedAt" class="text-muted fst-italic">
        —
      </span>
    </div>

    <!-- Close Button -->
    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-secondary px-4"
              (click)="closeViewModal()">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </div>

  </div>

</app-modal>

<!-- ADD PERIOD MODAL -->
<app-modal
  [title]="'ADMIN.ADD_ACADEMIC_PERIOD' | translate"
  [size]="'lg'"
  [show]="showAddModal"
  [hasFooter]="false"
  (closed)="closeAddModal()">

  <form (ngSubmit)="createPeriod()" #addForm="ngForm">

    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'DATA_TABLE.NAME' | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="newPeriod.name"
        name="name"
        required
        placeholder="e.g. Trimestre 1 – 2025/2026">
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'DATA_TABLE.START_DATE' | translate }}
      </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="newPeriod.startDate"
        name="startDate"
        required>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'DATA_TABLE.END_DATE' | translate }}
      </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="newPeriod.endDate"
        name="endDate"
        required>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-secondary"
              (click)="closeAddModal()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="addForm.invalid || isSaving">
        <span *ngIf="isSaving"
              class="spinner-border spinner-border-sm me-1"></span>
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>

  </form>

</app-modal>

<!-- EDIT PERIOD MODAL -->
<app-modal
  [title]="'ADMIN.EDIT_ACADEMIC_PERIOD' | translate"
  [size]="'lg'"
  [show]="showEditModal"
  [hasFooter]="false"
  (closed)="closeEditModal()">

  <form (ngSubmit)="updatePeriod()" #editForm="ngForm">

    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'DATA_TABLE.NAME' | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editPeriodData.name"
        name="editName"
        required>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'DATA_TABLE.START_DATE' | translate }}
      </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="editPeriodData.startDate"
        name="editStartDate"
        required>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'DATA_TABLE.END_DATE' | translate }}
      </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="editPeriodData.endDate"
        name="editEndDate"
        required>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-secondary"
              (click)="closeEditModal()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="editForm.invalid || isSaving">
        <span *ngIf="isSaving"
              class="spinner-border spinner-border-sm me-1"></span>
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>

  </form>

</app-modal>